import firebase from 'firebase';

import { INVITES } from '../collectionTypes';
import { processQuerySnapshotItems, rejectIfNotFound } from './utils';

const db = firebase.firestore();
const collection = db.collection(INVITES);

export function getInvites() {
  return collection
    .orderBy('created', 'desc')
    .get()
    .then(processQuerySnapshotItems);
}

export function getInvite(id) {
  return collection.doc(id)
    .get()
    .then(rejectIfNotFound);
}

export function createInvite(id, invite) {
  return collection.doc(id).set(invite);
}

export function removeInvite(id) {
  return collection.doc(id).delete();
}

export function isInviteActive(id) {
  return collection
    .doc(id)
    .get()
    .then(doc => doc.exists && !doc.data().registeredUser, () => false);
}



// WEBPACK FOOTER //
// ./src/firebase/repositories/invites.js